import { toast } from "sonner";
import { UserX, UserPlus, Trash2 } from "lucide-react";
import { api, coachHeaders } from "../lib/api";

export const HorsEffectifAlert = ({ rows, code, convocationId, onAdded }) => {
  const list = (Array.isArray(rows) ? rows : []).filter((r) => r.hors_effectif);
  if (list.length === 0) return null;
  const ajouter = async (r) => {
    try {
      await api.post("/joueurs", { nom: r.nom, prenom: r.prenom }, { ...coachHeaders(code), params: { convocation_id: convocationId } });
      toast.success(`${r.prenom} ajouté à l'effectif`);
      onAdded();
    } catch (e) { toast.error(e?.response?.data?.detail || "Ajout impossible"); }
  };
  const supprimer = async (cibles) => {
    const n = cibles.length;
    if (!window.confirm(n > 1 ? `Supprimer les ${n} réponses hors effectif ?` : `Supprimer la réponse de ${cibles[0].prenom} ${cibles[0].nom} ?`)) return;
    try {
      await Promise.all(cibles.map((r) => api.delete(`/reponses/${r.id}`, coachHeaders(code))));
      toast.success(n > 1 ? `${n} réponses supprimées` : "Réponse supprimée");
      onAdded();
    } catch { toast.error("Suppression impossible"); }
  };
  const n = list.length;
  return (
    <div data-testid="coach-hors-effectif-alert" role="alert" className="mt-4 flex items-start gap-3 rounded-2xl border border-signal bg-signal/15 p-4 text-chalk">
      <UserX className="mt-0.5 h-5 w-5 shrink-0 text-signal" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">
          Attention : {n} enfant{n > 1 ? "s" : ""} {n > 1 ? "ont" : "a"} répondu sans être dans l'effectif
        </p>
        <p className="mt-1 text-sm text-chalk">Vérifie l'orthographe du nom, ajoute l'enfant à l'effectif, ou supprime la réponse si c'est une erreur ou du spam.</p>
        <ul className="mt-2 space-y-1.5">
          {list.map((r) => (
            <li key={r.id} data-testid={`coach-hors-effectif-${r.id}`} className="flex flex-wrap items-center justify-between gap-2 text-sm">
              <span className="font-semibold">{r.prenom} {r.nom.toUpperCase()} <span className="font-normal text-chalk">· {r.statut === "present" ? "Présent" : "Absent"}</span></span>
              <span className="flex flex-wrap gap-1.5">
                <button data-testid={`coach-hors-effectif-add-${r.id}`} onClick={() => ajouter(r)}
                  className="inline-flex items-center gap-1 rounded-full border border-chalk/50 px-3 py-1 text-xs text-chalk transition-colors hover:border-lime hover:text-lime">
                  <UserPlus className="h-3.5 w-3.5" />Ajouter à l'effectif
                </button>
                <button data-testid={`coach-hors-effectif-delete-${r.id}`} onClick={() => supprimer([r])}
                  className="inline-flex items-center gap-1 rounded-full border border-signal px-3 py-1 text-xs text-signal transition-colors hover:bg-signal hover:text-ink">
                  <Trash2 className="h-3.5 w-3.5" />Supprimer
                </button>
              </span>
            </li>
          ))}
        </ul>
        {n > 1 && (
          <button data-testid="coach-hors-effectif-delete-all" onClick={() => supprimer(list)}
            className="mt-3 inline-flex items-center gap-1 rounded-full bg-signal px-4 py-1.5 text-xs font-semibold text-ink">
            <Trash2 className="h-3.5 w-3.5" />Supprimer les {n} réponses (spam)
          </button>
        )}
      </div>
    </div>
  );
};
